import { FaqItemId } from '@anm/data/faq/wave/wavePricingFaqData';
import { useEffect, useState } from 'react';

import routes from '../../../../routes';

const { Router } = routes;

const useCollapseQuestions = () => {
  const [collapseQuestion, setCollapseQuestion] = useState<
    FaqItemId[] | undefined
  >();

  useEffect(() => {
    setCollapseQuestion([Router?.query?.cq as FaqItemId]);
  }, []);

  return [collapseQuestion];
};

export default useCollapseQuestions;
